/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DatastoreSpec { 
    /**
     * Datastore Id
     */
    id?: string;
    /**
     * Max queue depth
     */
    maxQDepth?: number;
    /**
     * name of the datastore
     */
    name?: string;
    /**
     * datastore state
     */
    state?: DatastoreSpec.StateEnum;
    /**
     * NFS IP
     */
    storageEndpoint?: string;
    /**
     * Volume path
     */
    volumePath?: string;
}
export namespace DatastoreSpec {
    export type StateEnum = 'DELETED' | 'DELETION_IN_PROGRESS' | 'DELETION_FAILED' | 'CREATED' | 'CREATION_IN_PROGRESS' | 'CREATION_FAILED';
    export const StateEnum = {
        DELETED: 'DELETED' as StateEnum,
        DELETION_IN_PROGRESS: 'DELETION_IN_PROGRESS' as StateEnum,
        DELETION_FAILED: 'DELETION_FAILED' as StateEnum,
        CREATED: 'CREATED' as StateEnum,
        CREATION_IN_PROGRESS: 'CREATION_IN_PROGRESS' as StateEnum,
        CREATION_FAILED: 'CREATION_FAILED' as StateEnum
    };
}


